import { useTranslation } from 'react-i18next'
import { AbsencesForm } from './absences-form'
import { useModalContext } from '../../provider/modal-provider'
import { useParams } from 'react-router-dom'
import { Form } from '@shared/ui'
import { useSchemaUnavailableSlot } from './schema'
import {
  parseCustomDate,
  getDayWithExactHour,
  useRouteState,
} from '@shared/utils'
import { AbsencesAppointmentState } from './state'
import { EVENT_FORM, useModalForm } from '../../common'
import { useEffect, useState } from 'react'
import { useLayoutContext } from '@sr/routes/common/layout-provider'
import { SRModal } from '@sr/ui'
import { NotifyChangesModal } from '../care/notify-changes-modal'

export const Absences = ({
  isReadOnly,
  isEdit,
  actionAfterSubmit,
  onClose,
}) => {
  const { t } = useTranslation()
  const { id: socialReferentId } = useParams()
  const {
    eventId,
    appointmentType,
    appointmentDay,
    unavailableSlotType,
    startTime,
    endTime,
  } = useModalContext()
  const { setIsLoading } = useLayoutContext()

  const { isLoading, saveAbsence, createAbsence, deleteAbsence } =
    useRouteState(AbsencesAppointmentState)

  const defaultValues = {
    [EVENT_FORM.appointmentType]: appointmentType,
    [EVENT_FORM.appointmentDay]: appointmentDay,
    [EVENT_FORM.unavailableSlotType]: unavailableSlotType,
    [EVENT_FORM.startDate]: startTime,
    [EVENT_FORM.endDate]: endTime,
  }
  const schema = useSchemaUnavailableSlot(t)
  const { methods } = useModalForm({ schema, defaultValues })

  const { handleSubmit } = methods
  const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false)
  const [pendingForm, setPendingForm] = useState(null)
  const [defaultNotifyClient, setDefaultNotifyClient] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const executeSubmit = async (form, shouldNotifyClient = true) => {
    setIsSubmitting(true)
    const { appointmentType, unavailableSlotType, allDay } = form
    const { startDate, endDate } = form
    let newStartDate = parseCustomDate(appointmentDay, startDate)
    let newEndDate = parseCustomDate(appointmentDay, endDate)

    if (allDay) {
      newStartDate = getDayWithExactHour(appointmentDay, { hour: 9, minute: 0 })
      newEndDate = getDayWithExactHour(appointmentDay, {
        hour: 18,
        minute: 0,
      })
    }

    const eventForm = {
      startDate: newStartDate,
      endDate: newEndDate,
      id: eventId || '',
      appointmentType,
      socialReferentId,
      unavailableSlotType,
      ...(isEdit && { notifyClient: shouldNotifyClient }),
    }
    console.log('eventForm', eventForm)
    const action = isEdit ? saveAbsence : createAbsence
    await action(eventForm)
    setIsSubmitting(false)
    actionAfterSubmit()
  }

  const onSubmit = handleSubmit(async (form) => {
    if (isEdit) {
      setPendingForm(form)
      setDefaultNotifyClient(true)
      setIsNotifyModalOpen(true)
      return
    }

    await executeSubmit(form, true)
  })

  const handleNotifyConfirm = async (shouldNotifyClient) => {
    setIsNotifyModalOpen(false)
    if (pendingForm) {
      await executeSubmit(pendingForm, shouldNotifyClient)
      setPendingForm(null)
    }
  }

  const closeNotifyModal = () => {
    setIsNotifyModalOpen(false)
    setPendingForm(null)
  }

  const onDelete = () => {
    deleteAbsence(eventId).then(() => {
      actionAfterSubmit()
    })
  }

  useEffect(() => {
    setIsLoading(isLoading || isSubmitting)
  }, [isLoading, isSubmitting])

  if (isLoading && !isSubmitting) return

  return (
    <>
      <SRModal onClose={onClose}>
        <Form methods={methods}>
          <AbsencesForm
            onSubmit={onSubmit}
            isReadOnly={isReadOnly}
            isEdit={isEdit}
            onDelete={onDelete}
          />
        </Form>
      </SRModal>

      <NotifyChangesModal
        open={isNotifyModalOpen}
        defaultChecked={defaultNotifyClient}
        onConfirm={handleNotifyConfirm}
        onClose={closeNotifyModal}
        isLoading={isSubmitting}
      />
    </>
  )
}
